module.exports = __webpack_public_path__ + "static/media/APPLEPAY.d2cdf0de.svg";